/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetAddressSuggest401Response,
  GetCommonState400Response,
  GetPartnerSetting200Response,
  GetPartnerSetting404Response,
  GetPartnerSettings200Response,
  GetPartnerSettings403Response,
} from '../models/index'
import {
  GetAddressSuggest401ResponseFromJSON,
  GetAddressSuggest401ResponseToJSON,
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  GetPartnerSetting200ResponseFromJSON,
  GetPartnerSetting200ResponseToJSON,
  GetPartnerSetting404ResponseFromJSON,
  GetPartnerSetting404ResponseToJSON,
  GetPartnerSettings200ResponseFromJSON,
  GetPartnerSettings200ResponseToJSON,
  GetPartnerSettings403ResponseFromJSON,
  GetPartnerSettings403ResponseToJSON,
} from '../models/index'

export interface GetPartnerSettingRequest {
  group: string
  key: string
}

/**
 * PartnerApi - interface
 *
 * @export
 * @interface PartnerApiInterface
 */
export interface PartnerApiInterface {
  /**
   * Одна настройка партнёра текущей сессии по группе и ключу; при отсутствии значения у партнёра возвращается значение по умолчанию. Требуется подтверждённый email.
   * @summary Настройка партнёра по группе и ключу
   * @param {string} group Группа настройки
   * @param {string} key Ключ настройки
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PartnerApiInterface
   */
  getPartnerSettingRaw(
    requestParameters: GetPartnerSettingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetPartnerSetting200Response>>

  /**
   * Одна настройка партнёра текущей сессии по группе и ключу; при отсутствии значения у партнёра возвращается значение по умолчанию. Требуется подтверждённый email.
   * Настройка партнёра по группе и ключу
   */
  getPartnerSetting(
    requestParameters: GetPartnerSettingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetPartnerSetting200Response>

  /**
   * Все настройки партнёра текущей сессии: партнёр определяется по partner-scope токена (сессии, выпущенные через обмен одноразового кода клиентом партнёра) либо по роли PARTNER. Требуется подтверждённый email.
   * @summary Настройки партнёра
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PartnerApiInterface
   */
  getPartnerSettingsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetPartnerSettings200Response>>

  /**
   * Все настройки партнёра текущей сессии: партнёр определяется по partner-scope токена (сессии, выпущенные через обмен одноразового кода клиентом партнёра) либо по роли PARTNER. Требуется подтверждённый email.
   * Настройки партнёра
   */
  getPartnerSettings(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetPartnerSettings200Response>
}

/**
 *
 */
export class PartnerApi extends runtime.BaseAPI implements PartnerApiInterface {
  /**
   * Одна настройка партнёра текущей сессии по группе и ключу; при отсутствии значения у партнёра возвращается значение по умолчанию. Требуется подтверждённый email.
   * Настройка партнёра по группе и ключу
   */
  async getPartnerSettingRaw(
    requestParameters: GetPartnerSettingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetPartnerSetting200Response>> {
    if (requestParameters['group'] == null) {
      throw new runtime.RequiredError(
        'group',
        'Required parameter "group" was null or undefined when calling getPartnerSetting().'
      )
    }

    if (requestParameters['key'] == null) {
      throw new runtime.RequiredError(
        'key',
        'Required parameter "key" was null or undefined when calling getPartnerSetting().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/partner/settings/{group}/{key}`
          .replace(
            `{${'group'}}`,
            encodeURIComponent(String(requestParameters['group']))
          )
          .replace(
            `{${'key'}}`,
            encodeURIComponent(String(requestParameters['key']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetPartnerSetting200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Одна настройка партнёра текущей сессии по группе и ключу; при отсутствии значения у партнёра возвращается значение по умолчанию. Требуется подтверждённый email.
   * Настройка партнёра по группе и ключу
   */
  async getPartnerSetting(
    requestParameters: GetPartnerSettingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetPartnerSetting200Response> {
    const response = await this.getPartnerSettingRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Все настройки партнёра текущей сессии: партнёр определяется по partner-scope токена (сессии, выпущенные через обмен одноразового кода клиентом партнёра) либо по роли PARTNER. Требуется подтверждённый email.
   * Настройки партнёра
   */
  async getPartnerSettingsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetPartnerSettings200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/partner/settings`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetPartnerSettings200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Все настройки партнёра текущей сессии: партнёр определяется по partner-scope токена (сессии, выпущенные через обмен одноразового кода клиентом партнёра) либо по роли PARTNER. Требуется подтверждённый email.
   * Настройки партнёра
   */
  async getPartnerSettings(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetPartnerSettings200Response> {
    const response = await this.getPartnerSettingsRaw(initOverrides)
    return await response.value()
  }
}
